import React from 'react';
import { Loader2 } from 'lucide-react';
import { isCustomDomain } from '@/components/AppStoreBadges';
import { useEventsPage } from '@/lib/useEventsPage';
import EventItemCard from '@/components/events/EventItemCard';
import InviteFoil from '@/components/events/InviteFoil';
import '@/components/events/eventsInvite.css';

const HERO_FALLBACK = 'https://media.base44.com/images/public/6958216a4cd06732f9f425e2/2e0b9910e_generated_image.png';

export default function Events() {
  const { config, isLoading } = useEventsPage();
  // Items are stored as a snapshot when the admin saves the page.
  const items = config?.featured_items || [];

  if (isLoading) {
    return (
      <div className="flex justify-center py-20">
        <Loader2 className="w-6 h-6 animate-spin text-brand-navy" />
      </div>);
  }

  const published = config?.is_published;

  return (
    <div className={`inv-pg ${isCustomDomain() ? '' : 'pt-[max(env(safe-area-inset-top),1.5rem)] md:pt-0'}`}>
      <div className="inv-hero hidden md:block">
        <img className="bg" src={config?.hero_image_url || HERO_FALLBACK} alt="Popcorn, tickets and fairy lights flat-lay on linen" />
        <div className="scrim" />
        <div className="inv-lock">
          <p className="inv-script">Upcoming</p>
          <h1 className="inv-h1">{config?.hero_heading || 'Events'}</h1>
          <InviteFoil />
        </div>
      </div>

      {published && items.length > 0 ?
        <>
          <div className="inv-stack pt-10">
            {items.map((item) => <EventItemCard key={item.id} item={item} />)}
          </div>
        </> :
        <div className="inv-empty mx-4 lg:mx-auto">
          <h2>Events</h2>
          <p className="inv-sans">There are no events to show right now. Please check back soon.</p>
        </div>
      }
    </div>);
}